import { render, staticRenderFns } from "./AcquisitionHero.vue?vue&type=template&id=51c87468&scoped=true&"
import script from "./AcquisitionHero.vue?vue&type=script&lang=ts&"
export * from "./AcquisitionHero.vue?vue&type=script&lang=ts&"
import style0 from "./AcquisitionHero.vue?vue&type=style&index=0&id=51c87468&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c87468",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonSalesDialog: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonSalesDialog.vue').default})
